import { render, staticRenderFns } from "./QuoteManagement.vue?vue&type=template&id=58460da0&scoped=true"
import script from "./QuoteManagement.vue?vue&type=script&lang=js"
export * from "./QuoteManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58460da0",
  null
  
)

export default component.exports